import React from "react";
import { StateInspectorAnchor } from "./StateInspector";
import { lightInspectorTheme } from "./inspectorTheme";

export function StateInspectorToggleButton({
  showInspector,
  setShowInspector,
  theme,
  anchor,
}: {
  showInspector: boolean;
  setShowInspector: (value: boolean) => void;
  theme: typeof lightInspectorTheme;
  anchor: StateInspectorAnchor;
}) {
  const isRightAnchor = anchor === "right";

  const rightIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="size-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5"
      />
    </svg>
  );

  const leftIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="size-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m18.75 4.5-7.5 7.5 7.5 7.5m-6-15L5.25 12l7.5 7.5"
      />
    </svg>
  );

  return (
    <span
      role="button"
      style={{
        flex: "0",
        appearance: "none",
        color: theme.BASE_COLOR,
        border: "none",
        fontSize: "12px",
        whiteSpace: "nowrap",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2px 0",
      }}
      onClick={(event) => {
        event.stopPropagation();

        setShowInspector(!showInspector);
      }}
    >
      {showInspector ? (
        "Hide Inspector"
      ) : (
        <span style={{ width: "12px", height: "12px" }}>
          {isRightAnchor ? rightIcon : leftIcon}
        </span>
      )}
    </span>
  );
}
